import { Box, VStack, Heading, useToast } from "@chakra-ui/react";
import EventForm from "./components/EventForm";
import { AdminEventsEndpoints, fetcher } from "@olagg/api-hooks";
import { ApiEvent } from "@olagg/db-types";
import { useParams } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import useEvents from "./hooks/useEvents";
import { useEffect, useState } from "react";

const UpdateEvent = () => {
    const [event, setEvent] = useState<ApiEvent | null>(null);
    const toast = useToast();
    const { id } = useParams<{ id: string }>();
    const { getEvent } = useEvents();

    const onSubmit = (dataForm: Partial<ApiEvent>, rescheduled: boolean) =>
        fetcher(AdminEventsEndpoints.update(id!, dataForm, rescheduled))
            .then(() => {
                toast({
                    title: 'Evento',
                    colorScheme: 'olaggPink',
                    status: 'success',
                    description: `Evento actualizado con éxito`,
                    position: 'bottom-right'
                });
                window.location.href = ROUTES.EVENTS.all;
            })
            .catch((error: Error) => {
                toast({
                    title: 'Error',
                    colorScheme: 'olaggYellow',
                    status: 'error',
                    description: error.error,
                    position: 'bottom-right'
                });
            })

    useEffect(() => {
        if (id) {
            getEvent(id).then(setEvent)
        }
    }, [id]);

    if (!event) {
        return <Box>Loading...</Box>;
    }

    return (
        <Box w={'full'} pb={4} minH='600px'>
            <VStack color={'white'} w={'full'}>
                <Heading my={2}>Actualizar evento</Heading>
                <EventForm onSubmit={onSubmit} event={event} />
            </VStack>
        </Box>
    )
};

export default UpdateEvent;